import { render, staticRenderFns } from "./apm-bank-transfer.vue?vue&type=template&id=5d7ea123&scoped=true"
import script from "./apm-bank-transfer.vue?vue&type=script&lang=js"
export * from "./apm-bank-transfer.vue?vue&type=script&lang=js"
import style0 from "./apm-bank-transfer.vue?vue&type=style&index=0&id=5d7ea123&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d7ea123",
  null
  
)

export default component.exports